import React from 'react';
import PropTypes from 'prop-types';

export default function SearchBox(props) {
  const {
    queryRef,
    query,
    setQuery,
    hideSearch,
    placeholder = '',
  } = props;

  if (hideSearch === true) {
    return null;
  }

  return (
    <div className="snapgadget_search_container">
      <input
        className="snapgadget_query"
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        ref={queryRef}
      />
      <button className="snapgadget_search snapgadget-btn" type="submit">
        Search
      </button>
    </div>
  );
}

SearchBox.propTypes = {
  queryRef: PropTypes.object,
  query: PropTypes.string,
  setQuery: PropTypes.func,
  hideSearch: PropTypes.bool,
  placeholder: PropTypes.string,
};
